
    <div class="{{fxMedia == 'mobile' ? '' : 'fx_modal_container'}}" appModalDrag>
      <!-- 标题栏 -->
      <div class="{{fxMedia == 'mobile' ? 'p-3 border-bottom' : 'fx_modal_title fx'}}">
        <div class="{{fxMedia == 'mobile' ? 'w-100 d-flex align-items-center justify-content-between' : 'fx_le_title'}}">
          <div>
            <i class="me-2 anticon anticon-{{iconType}}"></i>
            <span>{{ title }}</span>
          </div>
          <button *ngIf="fxMedia == 'mobile'" type="button" class="btn-close" (click)="modalClose()"></button>
        </div>
      </div>
      <!-- 消息区域 -->
      <div class="fx_modal_content">
        <div dw-row>
          <span>{{ message }}</span>
          <span *ngIf="program_name">请查询 <a href="javascript: void(0)" (click)="openMenu(program_no)">{{program_name}}</a> 作业</span>
        </div>

      <!-- 更多消息区域 -->
      <div class="fx-modal-content-more" *ngIf="hasMoreContent">
        <!-- show more -->
        <div dw-row *ngIf="!showMoreContent" (click)="showMoreContent = !showMoreContent">
          <i class="anticon anticon-plus-square-o color-info"></i>
          <span>更多信息</span>
        </div>
        <!-- hide more -->
        <div dw-row *ngIf="showMoreContent" (click)="showMoreContent = !showMoreContent">
          <i class="anticon anticon-minus-square-o color-info"></i>
          <span>隐藏更多信息</span>
        </div>
        <!-- more content -->
        <div dw-row *ngIf="showMoreContent">
          <textarea rows="4" dw-input [ngModel]="moreInfo" disabled></textarea>
        </div>
      </div>
      </div>
    </div>
  